import type { FC } from "react"
import React from "react"

import { Box, Paper } from "@mui/material"
import type { SxProps, Theme } from "@mui/material/styles"

import { SectionHeader } from "../section-header/section-header"
import type { PageCardProps } from "./page-card.types"

export const PageCard: FC<PageCardProps> = ({
  title,
  children,
  sx,
  ...rest
}) => (
  <Paper {...rest} sx={[{ p: 3 }, sx] as SxProps<Theme>}>
    {title ? (
      <Box
        sx={{
          mb: 2,
        }}
      >
        <SectionHeader title={title} />
      </Box>
    ) : null}
    {children}
  </Paper>
)
